import React from 'react'
import { getTeamInfo } from 'meinian-package/src/common/userInfo'
import * as userAuth from 'meinian-package/src/utils/auth'
import Rank, { RANK_DEFAULT_VALUE } from 'component/filter/rank'
import Filter from '../../../../components/styleFilter'
import { BatchSelect, BatchDownload, BatchExport } from '../../../../components/batch'
import styles from './index.module.less'

export default ({
  onChange,
  params,
  info,
  isChild,
  auth,
  styleFilterCount,
  hasFilter,
  setHasFilter,
  setBatchValue,
  defaultParams,
  setParams,
  setStyleFilterCount,
}) => {
  const teamInfo = getTeamInfo()
  return <div className={styles.operation}>
    {
      userAuth.hasInspirationAuth(isChild, auth, ['F02', 'FC03']) && <Filter
        styleFilterCount={styleFilterCount}
        displayTextClassName="fill-white-bg"
        hasFilter={hasFilter}
        currentData={{
          inspirationId: info.id,
          needMarkTimes: info.needMarkTimes
        }}
        visible={hasFilter}
        value={params}
        defaultParams={defaultParams}
        onChange={(val) => {
          if (JSON.stringify(val) == '{}') { // 空对象则是清空
            setParams({ ...defaultParams })
            return
          }
          if (+(params.platformIdList?.[0] || '') !== +(val.platformIdList?.[0] || '')) {
            setParams({ ...val, ...RANK_DEFAULT_VALUE })
          } else {
            setParams({ ...val })
          }
        }}
        onCancel={() => setHasFilter(false)}
        onCount={(val) => {
          setStyleFilterCount(val)
        }}
        setHasFilter={(val) => {
          setHasFilter(val)
          setBatchValue(null)
        }}
      />
    }
    <div style={{ marginRight: '8px' }}>
      <Rank
        trigger="click"
        placement="bottomRight"
        displayTextClassName="fill-white-bg"
        value={params}
        platformId={params.platformId}
        onChange={val => {
          setParams(pre => ({ ...pre, ...val }))
        }}
      />
    </div>
    {
      teamInfo.id && <BatchDownload
        inspirationId={info.id}
        onChange={onChange}
      />
    }
    {
      (!auth.includes('F02') && !auth.includes('FC03')) ? null : <BatchExport
        auth={auth}
        inspirationId={info.id}
        onChange={onChange}
        style={{ marginLeft: '8px' }}
      />
    }
    <BatchSelect
      style={{ marginLeft: '8px' }}
      markStatus={params?.markStatus}
      markTimes={params?.markTimes}
      permissions={info?.loginUserInfo?.role}
      onChange={onChange}
      guideStyle={{ right: 0, top: -140 }}
    />
  </div>
}
